const wrapper = "_275w1gcz9dk";
const userGreeting = "_275u1ghxm8h";
const heading = "_275h13inuv6";

export { heading, userGreeting, wrapper };
import "./molecule.location-section.style.linaria.module.css";
//# sourceMappingURL=molecule.location-section.style.js.map
